module.exports = __webpack_public_path__ + "static/1-dde40661e88567e6ee3aea9c0b6c53b5.jpg";